module.exports = __webpack_public_path__ + "static/media/coachman.918059ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/coachman.png
// module id = 76
// module chunks = 0